var _path, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNvgtrBmWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 535,
    height: 269,
    viewBox: "0 0 535 269",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M253.902 1.07947C198.292 5.23947 163.672 93.8695 139.282 136.449C121.792 166.979 89.2124 228.159 47.7624 225.679C35.8124 224.969 29.0124 216.019 15.7024 217.859C7.90242 218.939 0.60242 227.559 0.0524198 235.229C-1.38758 255.499 27.1824 266.329 43.6324 267.749C140.032 276.109 184.832 129.739 228.302 67.4495C244.452 44.3095 269.312 34.6195 275.842 70.5395C285.462 123.379 268.722 230.809 331.132 257.249C375.262 275.939 412.082 233.849 434.932 202.089C442.412 191.699 466.812 158.899 469.832 148.989C474.522 133.609 464.622 119.739 448.052 123.209C439.522 124.999 432.862 133.489 427.712 139.869C408.662 163.459 351.522 269.389 329.592 187.779C319.462 150.069 323.562 107.889 318.982 69.3895C314.812 34.4695 293.822 -1.91053 253.902 1.07947Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 499,
    cy: 60.9069,
    r: 36,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNvgtrBmWhite);
export default __webpack_public_path__ + "static/media/nvgtr_BM_white.efdaa1ad46ddd5cf952ddee0b831266a.svg";
export { ForwardRef as ReactComponent };